import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    readonly width?: string;
    readonly height?: string;
}

const BookmarkStarIcon: React.FC<IconProps> = ({ ...props }) => (
    <svg
        width='141'
        height='140'
        viewBox='0 0 141 140'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <g id='bookmark_star'>
            <mask
                id='mask0_2306_8238'
                type='alpha'
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='141'
                height='140'
            >
                <rect id='Bounding box' x='0.5' width='140' height='140' fill='#D9D9D9' />
            </mask>
            <g mask='url(#mask0_2306_8238)'>
                <path
                    id='bookmark_star_2'
                    d='M58.2384 80.0968L70.5 72.6928L82.7617 80.0968L79.4848 66.1085L90.3115 56.7751L76.1205 55.5749L70.5 42.4047L64.8796 55.5749L50.6886 56.7751L61.5153 66.1085L58.2384 80.0968ZM32.5834 118.126V28.2705C32.5834 26.0121 33.4137 24.0453 35.0742 22.3701C36.7348 20.695 38.7089 19.8574 40.9965 19.8574H100.004C102.291 19.8574 104.265 20.695 105.926 22.3701C107.586 24.0453 108.417 26.0121 108.417 28.2705V118.126L70.5 101.86L32.5834 118.126ZM39.2028 107.996L70.5 94.7137L101.797 107.996V28.2705C101.797 27.8214 101.611 27.4101 101.237 27.0368C100.863 26.6625 100.452 26.4753 100.004 26.4753H40.9965C40.5483 26.4753 40.1371 26.6625 39.7628 27.0368C39.3894 27.4101 39.2028 27.8214 39.2028 28.2705V107.996Z'
                    fill='#CEBDE6'
                />
            </g>
        </g>
    </svg>
);

export { BookmarkStarIcon };
